
import { createSlice } from "@reduxjs/toolkit";
import { loginUser, logoutUser } from "./authThunks";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isLoading: false,
    auth_info: JSON.parse(localStorage.getItem("auth_info")),
    user: JSON.parse(localStorage.getItem("auth_info"))?.userInfo || null,
    token: localStorage.getItem("token") || null,
    status: "idle",
    isAuthenticated: !!localStorage.getItem("token"),
    error: null,
  },
  reducers: {
     setSwitchBranch(state, action) {
      state.auth_info = { ...state.auth_info, ...action.payload };
      state.user = action.payload.userInfo || null;
      state.token = action.payload.token;
    }
  },
  extraReducers: (builder) => {
    builder
      // 🚀 LOGIN
      .addCase(loginUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.isAuthenticated = true;
        state.auth_info = action.payload;
        state.user = action.payload.userInfo || null;
        state.token = action.payload.token;

        localStorage.setItem("token", action.payload.token);
        localStorage.setItem("auth_info", JSON.stringify(action.payload));

        state.isLoading = false;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.isAuthenticated = false;
        state.isLoading = false;
        state.error = action.payload || "Login failed.";
        // localStorage.clear();
          localStorage.removeItem("token");
  localStorage.removeItem("auth_info");
        sessionStorage.clear();
      })

      // 🚀 LOGOUT (always clears state + storage)
      .addCase(logoutUser.fulfilled, (state) => {
        state.auth_info = null;
        state.user = null;
        state.token = null;
        state.isAuthenticated = false;
        state.error = null;
        state.isLoading = false;
        // localStorage.clear();
          localStorage.removeItem("token");
  localStorage.removeItem("auth_info");
        sessionStorage.clear();
      })
      .addCase(logoutUser.rejected, (state) => {
        state.auth_info = null;
        state.user = null;
        state.token = null;
        state.isAuthenticated = false;
        // localStorage.clear();
          localStorage.removeItem("token");
  localStorage.removeItem("auth_info");
        sessionStorage.clear();
      });
  },
});
export const { setSwitchBranch } = authSlice.actions; 
export default authSlice.reducer;
